/**
 * @flow
 * Created by neo on 28.05.17.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import FlightOfferAvailability from '../../../Store/FlightOffer/FlightOfferAvailability';
import { Input, FormGroup, Label } from 'reactstrap';
import { translate  } from 'react-i18next';
import { Alert } from 'reactstrap';

const moment = require('moment');

type Props = {
  availability: FlightOfferAvailability,
  onChanged: (startTime: string) => void,
};

@observer
export class TimeRangePicker extends Component {
  props: Props;
  state: {
    focused: boolean,
    date: any,
    currentDate: any,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      availability: null,
      focused: false,
      date: null,
      currentDate: moment(),
    };
  }

  render() {
    const { availability, t, label } = this.props;
    const currentDate = moment().format('YYYY-MM-DD');

    if (availability && availability.times && availability.times.length > 0) {
      return (
        <div className='separator'>
          <FormGroup className='mb-4'>
            {label && <Label>{label}</Label>}
            <Input type='select' bsSize='sm' onChange={e => this.props.onChanged(e.target.value)}>
              {availability.times.filter(t => availability.target_date !== currentDate || t.start > moment().format('HH:MM')).map((t, i) => {
                return <option key={i} value={t.start}>{`${t.meeting_time} - ${t.dropoff_time}`}</option>;
              })}
            </Input>
          </FormGroup>
        </div>
      );
    }


    // target date is selected
    if (availability && availability.target_date) {
      return (<Alert color='danger'>{t('No flights available')}</Alert>);
    }

    return null;
  }
}

export default translate ()(TimeRangePicker);


// WEBPACK FOOTER //
// ./src/App/FlightOffer/View/Booking/TimeRangePicker.js